import { combineReducers } from "redux";
import mutualFundsAllTransactionsReducer from "./MutualFundAllTransactionsReducers";
import mutualFundsSIP_STP_SWP_TransactionsReducer from "./MutualFundSIP_STP_SWP_TransactionsReducers";
import mutualFundTransactionsCommonReducer from "./MutualFundTransactionsCommonReducer";
import mutualFundsMandateTransactionsReducer from "./MutualFundMandateTransactionsReducers";
import mutualFundsTransferInReducer from "./MutualFundTransferInReducers";
export default combineReducers({
    mutualFundsAllTransactionsReducer: mutualFundsAllTransactionsReducer,
    mutualFundsSIP_STP_SWP_TransactionsReducer: mutualFundsSIP_STP_SWP_TransactionsReducer,
    mutualFundTransactionsCommonReducer: mutualFundTransactionsCommonReducer,
    mutualFundsMandateTransactionsReducer: mutualFundsMandateTransactionsReducer,
    mutualFundsTransferInReducer: mutualFundsTransferInReducer,
});
